import { useParams, Link } from 'wouter';
import { Footer } from '@/components/sections/Footer';
import { PageBreadcrumb } from '@/components/sections/PageBreadcrumb';
import { useSeo } from '@/lib/useSeo';
import { cmsPublicPath } from '@/cms/content';
import { DistrictLandingPage, NearbyTownLandingPage } from '@/pages/local-seo/LocalLandingPages';
import { findLocalSeoLocation } from '@/data/localSeoLocations';

const GOLD   = '#e05590';
const DARK   = '#2a1f14';
const MUTED  = 'rgba(42,31,20,0.48)';
const LINE   = 'rgba(210,60,120,0.18)';
const CREAM  = '#faf7f2';

function UnknownLocalSeoLocation({ isDistrict }: { isDistrict: boolean }) {
  useSeo({ title: 'Dostawa kwiatów — Bukietowa Lublin' });
  return (
    <div style={{ background: '#fff', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <PageBreadcrumb crumbs={[
        isDistrict
          ? { label: 'Kwiaciarnia Lublin', href: '/kwiaciarnia-lublin/' }
          : { label: 'Okolice Lublina', href: '/kwiaciarnia-okolice/' },
        { label: 'Nie znaleziono lokalizacji' },
      ]} />
      <main style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 'clamp(64px,10vw,120px) 24px', textAlign: 'center' }}>
        <div style={{ maxWidth: 520 }}>
          <h1 style={{ fontFamily: 'Cormorant Garamond, Georgia, serif', fontSize: 'clamp(2rem,4vw,3rem)', fontWeight: 400, color: DARK, margin: '0 0 16px' }}>Nie znaleziono lokalizacji</h1>
          <p style={{ fontFamily: 'DM Sans, sans-serif', fontSize: 14, color: MUTED, marginBottom: 32 }}>Sprawdź, czy adres URL jest poprawny, lub wróć na stronę dostawy.</p>
          <Link href="/dostawa/" style={{ fontFamily: 'DM Sans, sans-serif', fontSize: 11, letterSpacing: '0.18em', textTransform: 'uppercase', color: DARK, border: `1px solid ${LINE}`, padding: '13px 28px', textDecoration: 'none' }}>Informacje o dostawie</Link>
        </div>
      </main>
      <Footer showDeliveryAreas={false} />
    </div>
  );
}

export default function DzielnicaPage() {
  const params = useParams<{ slug: string }>();
  const slug = params.slug ?? '';
  const isDistrict = cmsPublicPath().includes('/kwiaciarnia-lublin/');
  const location = findLocalSeoLocation(isDistrict ? 'district' : 'nearbyTown', slug);

  if (!location) {
    return <UnknownLocalSeoLocation isDistrict={isDistrict} />;
  }

  return isDistrict ? <DistrictLandingPage location={location} /> : <NearbyTownLandingPage location={location} />;
}
